import React, { Component } from "react";
import { connect } from "react-redux";
import { propValueOr, verifyPermission } from "../../helpers/common";
import { Container, ContentCard, Header, Filter, FilterItem } from "./styled";
import { Switch, Route, withRouter } from "react-router-dom";
import { routes } from "./routes";

class RouteWallet extends Component {
  handleChangeFilter = value => {
    this.setState({ filter: value });
  };

  render() {
    return (
      <Container>
        <ContentCard>
          <Switch>
            {routes.map((route, index) => {
              return (
                <Route
                  key={index}
                  exact={route.exact}
                  path={route.path}
                  render={() => {
                    return (
                      <Header>
                        <Filter>
                          {!propValueOr(
                            this.props.user,
                            "info.organizationId"
                          ) && (
                            <FilterItem
                              key={"wallet"}
                              to={"/wallet"}
                              isActive={window.location.pathname === "/wallet"}
                              onClick={() => this.handleChangeFilter("wallet")}
                            >
                              WALLETS
                            </FilterItem>
                          )}
                          <FilterItem
                            key={"transactions"}
                            to={"/wallet/transactions"}
                            isActive={window.location.pathname.includes(
                              "/wallet/transactions"
                            )}
                            onClick={() =>
                              this.handleChangeFilter("transactions")
                            }
                          >
                            TRANSACTIONS
                          </FilterItem>
                          {verifyPermission(
                            "/wallet",
                            this.props.permissions
                          ) === "admin" && (
                            <FilterItem
                              key={"transfer"}
                              to={"/wallet/transfer"}
                              isActive={window.location.pathname.includes(
                                "/wallet/transfer"
                              )}
                              onClick={() =>
                                this.handleChangeFilter("transfer")
                              }
                            >
                              TRANSFER
                            </FilterItem>
                          )}
                        </Filter>
                      </Header>
                    );
                  }}
                />
              );
            })}
          </Switch>
          <Switch>
            {routes.map(route => {
              const Component = route.component;
              return (
                <Route
                  key={route.path}
                  exact={route.exact}
                  path={route.path}
                  render={() => {
                    return (
                      <Component
                        {...this.props}
                        user={this.props.user}
                        permission={verifyPermission(
                          !!route.altPermission
                            ? route.altPermission
                            : route.path,
                          this.props.permissions
                        )}
                      />
                    );
                  }}
                />
              );
            })}
          </Switch>
        </ContentCard>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  permissions: state.permissionsState.permissions
});
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RouteWallet));
